module.exports = __webpack_public_path__ + "static/img/icon3.bc4b601b.svg";